module.exports = __webpack_public_path__ + "media/images/flags/ck-65a80cb3a138985c22dcde8234f36142.svg";